import Dialog from 'src/componentes/dialog';
import { useRef } from 'react';
import GerarCopiaControlada from './GerarCopiaControlada';

function GerarCopiaControladaModal({
  remove,
  onSuccess,
  quantidadePermitidaCopias,
  arquivo,
  urlCustom,
  convertWordToPdf,
  parameters,
  index,
}) {
  const dialogRef = useRef(null);

  const handleClose = () => {
    if (dialogRef.current) {
      dialogRef.current.close();
      return;
    }

    remove && remove();
  };

  return (
    <Dialog
      ref={dialogRef}
      remove={remove}
      index={index}
      width="550px"
      maxWidth="95%"
      title="labelGerarCopiaControlada"
      padContent
    >
      <GerarCopiaControlada
        handleClose={handleClose}
        onSuccess={onSuccess}
        quantidadePermitidaCopias={quantidadePermitidaCopias}
        arquivo={arquivo}
        urlCustom={urlCustom}
        convertWordToPdf={convertWordToPdf}
        parameters={parameters}
      />
    </Dialog>
  );
}

export default GerarCopiaControladaModal;
